<template>
  <div id="wrapper">

    <side-menu></side-menu>

    <div id="page-wrapper" class="gray-bg">

      <nav-menu></nav-menu>

      <bread-crumps title='Página Principal' action='Visualizar'/>

      <div class="wrapper wrapper-content animated fadeIn">
        <products-component></products-component>
      </div>

      <page-footer></page-footer>

    </div>
  </div>
</template>

<script>

  import NavMenu from './layout/NavMenu'
  import SideMenu from './layout/SideMenu'
  import BreadCrumps from './layout/BreadCrumps'
  import PageFooter from './layout/PageFooter'
  import ProductsComponent from './ProductsComponent'

  import { httpService } from '../providers/http-service'

  import { permissions } from '../mixins/permissions'
  import { toast } from '../mixins/toast'

  export default {
    mixins: [ toast, permissions ],
    components: { NavMenu, SideMenu, BreadCrumps, PageFooter, ProductsComponent },
    data () {
      return {

      }
    },
    mounted() {
      //console.log('$store ', this.$store.state)
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/HomePage.vue